import {GetExamResults} from 'domain/usecases';

import {RemoteGetExamResults} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamResults = (): GetExamResults =>
	new RemoteGetExamResults(
		makeBFFApiUrl(BookedFlowEndPoints.examResults),
		makeAuthorizeHttpClientDecorator(),
	);
